import React from "react";
const IconAppointmentIllustration = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="57"
    height="56"
    viewBox="0 0 57 56"
    fill="none"
    {...props}
  >
    <circle
      cx="41.5"
      cy="42"
      r="8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <path
      d="M36.5 41.7692L40.1364 45L46.5 39"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <rect x="27.5" y="27" width="3" height="3" rx="1.5" fill="currentColor" />
    <rect x="27.5" y="35" width="3" height="3" rx="1.5" fill="currentColor" />
    <rect x="37.5" y="27" width="3" height="3" rx="1.5" fill="currentColor" />
    <rect x="17.5" y="27" width="3" height="3" rx="1.5" fill="currentColor" />
    <rect
      x="17.5"
      y="9"
      width="5"
      height="8"
      rx="2.5"
      stroke="currentColor"
      strokeWidth="2"
    />
    <rect
      x="34.5"
      y="9"
      width="5"
      height="8"
      rx="2.5"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 13H13.5C11.2909 13 9.5 14.7909 9.5 17V22V41C9.5 43.2091 11.2909 45 13.5 45H34.0815C33.8262 44.3693 33.649 43.6986 33.5619 43H13.5C12.3954 43 11.5 42.1046 11.5 41V23H45.5V35.0703C46.2528 35.5057 46.9281 36.0604 47.5 36.7084V22V17C47.5 14.7909 45.7091 13 43.5 13H39.5V14.5C39.5 14.6712 39.4828 14.8384 39.45 15H43.5C44.6046 15 45.5 15.8954 45.5 17V21H11.5V17C11.5 15.8954 12.3954 15 13.5 15H17.55C17.5172 14.8384 17.5 14.6712 17.5 14.5V13ZM22.45 15H34.55C34.5172 14.8384 34.5 14.6712 34.5 14.5V13H22.5V14.5C22.5 14.6712 22.4828 14.8384 22.45 15Z"
      fill="currentColor"
    />
    <rect x="17.5" y="35" width="3" height="3" rx="1.5" fill="currentColor" />
  </svg>
);
export default IconAppointmentIllustration;
